import { render, staticRenderFns } from "./ClientAssessment.vue?vue&type=template&id=2887d16a&scoped=true"
import script from "./ClientAssessment.vue?vue&type=script&lang=js"
export * from "./ClientAssessment.vue?vue&type=script&lang=js"
import style0 from "./ClientAssessment.vue?vue&type=style&index=0&id=2887d16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887d16a",
  null
  
)

export default component.exports